import { render, staticRenderFns } from "./talisman.vue?vue&type=template&id=62531b3d&scoped=true&"
import script from "./talisman.vue?vue&type=script&lang=js&"
export * from "./talisman.vue?vue&type=script&lang=js&"
import style0 from "./talisman.vue?vue&type=style&index=0&id=62531b3d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62531b3d",
  null
  
)

export default component.exports